import { buildImageSrc } from '@core/image'
import type { TImageResize } from '@ds/components'

export const HERO_COVER_SIZES = '240px'

export const HERO_COVER_RESIZE: TImageResize = {
    widths: [240, 480, 720],
    deviceWidths: [240, 480, 720],
    buildSrc: buildImageSrc,
}
